import { render, staticRenderFns } from "./CadastrosIndividuais.vue?vue&type=template&id=d163548c&scoped=true"
import script from "./CadastrosIndividuais.vue?vue&type=script&lang=js"
export * from "./CadastrosIndividuais.vue?vue&type=script&lang=js"
import style0 from "./CadastrosIndividuais.vue?vue&type=style&index=0&id=d163548c&prod&lang=css"
import style1 from "./styles.scss?vue&type=style&index=1&id=d163548c&prod&scoped=true&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d163548c",
  null
  
)

export default component.exports